import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useCallback } from 'react';

var useHiddenController = function useHiddenController() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var onShow = useCallback(function () {
    return setVisible(true);
  }, [visible]);
  var onHide = useCallback(function () {
    return setVisible(false);
  }, [visible]);
  var onToggle = useCallback(function () {
    return setVisible(!visible);
  }, [visible]);
  return {
    onShow: onShow,
    onHide: onHide,
    onToggle: onToggle,
    visible: initialState !== undefined ? initialState : visible
  };
};

export default useHiddenController;
//# sourceMappingURL=useHiddenController.js.map
